import React from 'react';
import AddOrEditTransporterVehicleForm from './AddOrEditTransporterVehicleForm';

/* React functional component */
const CreateTransporterVehicleScreen = () => {
  return <AddOrEditTransporterVehicleForm mode="add" />;
};

export default CreateTransporterVehicleScreen;
